import API from "@/models/API";

export default class SendReports {
    constructor(item = {}) {
        
    }
    
    static get = (query,status) =>
        API.get(
            `/suppliers/${localStorage.getItem("storeId")}/supplier-gifts${query}&status=${status}`
        );

    static uploadFile = (id, file) =>
        API.post(
            `/suppliers/${localStorage.getItem("storeId")}/supplier-gifts/${id}/upload?status=6`,
            file
        );
}
